import type { ReactNode } from 'react';

import { LogoFullOnDark } from '@/components/brand/Logo';
import { LocaleToggle, ThemeToggle } from '@/components/layout/Toggles';

/**
 * Общая рамка для экранов входа, регистрации и восстановления.
 * Слева — карточка формы, справа на широких экранах — спокойный блок о продукте,
 * чтобы страница не выглядела пустой.
 */
export function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <header className="flex items-center justify-between px-5 py-4 sm:px-8">
        <LogoFullOnDark className="h-6 w-auto" />
        <div className="flex items-center gap-2">
          <LocaleToggle />
          <ThemeToggle />
        </div>
      </header>

      <main className="flex flex-1 items-center justify-center px-5 py-8">
        <div className="w-full max-w-[380px]">
          <div className="rounded-card border border-border bg-surface p-7 shadow-card animate-rise">
            <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
            {subtitle && <p className="mt-1.5 text-[13.5px] text-muted">{subtitle}</p>}
            <div className="mt-6">{children}</div>
          </div>
          {footer && <div className="mt-4 text-center text-[13.5px] text-muted">{footer}</div>}
        </div>
      </main>
    </div>
  );
}
